"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var CannibalizationItem_1 = require("../model/CannibalizationItem");

var WindowPromoEffectSite_1 = require("../model/WindowPromoEffectSite");

var WindowPromoEffectSiteBase_1 = require("../model/WindowPromoEffectSiteBase");

var WindowPromoEffectSiteConverter_1 = require("./WindowPromoEffectSiteConverter");
/**
 * Default implementation of WindowPromoEffectSiteConverter.
 *
 * @author VSm
 * @author SMi
 * @author VRu
 */


var WindowPromoEffectSiteConverterImpl =
/*#__PURE__*/
function (_WindowPromoEffectSit) {
  _inherits(WindowPromoEffectSiteConverterImpl, _WindowPromoEffectSit);

  function WindowPromoEffectSiteConverterImpl() {
    _classCallCheck(this, WindowPromoEffectSiteConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowPromoEffectSiteConverterImpl).apply(this, arguments));
  }

  _createClass(WindowPromoEffectSiteConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new WindowPromoEffectSite_1.WindowPromoEffectSite(WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.id.valueOf(conversions.documentToClassId(source)), WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.windowId.valueOf(conversions.toClassReferenceId(source.windowId)), WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.products.valueOf(source.products.map(function (id) {
        return conversions.toClassReferenceId(id);
      })), WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.userTotalAmounts.valueOf(source.userTotalAmounts.map(function (item) {
        return conversions.toBigNumber(item);
      })), WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.positiveIncrementAmounts.valueOf(source.positiveIncrementAmounts.map(function (item) {
        return conversions.toBigNumber(item);
      })), WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.postPromoAmounts.valueOf(source.postPromoAmounts.map(function (item) {
        return conversions.toBigNumber(item);
      })), WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.postPromoDates.valueOf(source.postPromoDates.map(function (item) {
        return conversions.toDate(item);
      })), WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.baselineProducts.valueOf(source.baselineProducts.map(function (id) {
        return conversions.toClassReferenceId(id);
      })), WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.baselineAmounts.valueOf(source.baselineAmounts.map(function (item) {
        return conversions.toBigNumber(item);
      })), WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.cannibalization.valueOf(source.cannibalization.map(function (c) {
        return CannibalizationItem_1.CannibalizationItem.deserializeCannibalizationItem(c, conversions);
      })), WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.dailyTotals.valueOf(utils_1.Utils.asArray(source.dailyTotals).map(function (a) {
        return utils_1.Utils.asArray(a).map(function (n) {
          return conversions.toBigNumber(n);
        });
      })), WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.historic.valueOfField(source), WindowPromoEffectSiteBase_1.WindowPromoEffectSiteBase.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        windowId: conversions.toDocumentReferenceId(source.windowId),
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        products: source.products.map(function (item) {
          return conversions.toDocumentReferenceId(item);
        }),
        userTotalAmounts: source.userTotalAmounts.map(function (item) {
          return conversions.fromBigNumber(item);
        }),
        positiveIncrementAmounts: source.positiveIncrementAmounts.map(function (item) {
          return conversions.fromBigNumber(item);
        }),
        postPromoAmounts: source.postPromoAmounts.map(function (item) {
          return conversions.fromBigNumber(item);
        }),
        postPromoDates: source.postPromoDates.map(function (item) {
          return conversions.fromDate(item);
        }),
        baselineProducts: source.baselineProducts.map(function (item) {
          return conversions.toDocumentReferenceId(item);
        }),
        baselineAmounts: source.baselineAmounts.map(function (item) {
          return conversions.fromBigNumber(item);
        }),
        cannibalization: source.cannibalization.map(function (c) {
          return CannibalizationItem_1.CannibalizationItem.serializeCannibalizationItem(c, conversions);
        }),
        dailyTotals: source.dailyTotals.map(function (a) {
          return a.map(function (n) {
            return conversions.fromBigNumber(n);
          });
        }),
        historic: source.historic,
        siteId: conversions.toDocumentReferenceId(source.siteId)
      });
      return result;
    }
  }]);

  return WindowPromoEffectSiteConverterImpl;
}(WindowPromoEffectSiteConverter_1.WindowPromoEffectSiteConverter);

exports.WindowPromoEffectSiteConverterImpl = WindowPromoEffectSiteConverterImpl;